// Class
import { SmartTagBase } from './smartTagBase';
// Model
import { SmartTagModel } from './smartTag.model';

export class SmartTagConvertedGarageModel extends SmartTagModel {
	isGarageBeenConverted?: boolean;

	constructor() {
		super();
		this.isGarageBeenConverted = false;
	}
}

export class SmartTagConvertedGarage extends SmartTagBase {

	/**
	 * Renderer
	 * @param data SmartTagViewModel
	 */
	public render(data: SmartTagConvertedGarageModel, version?: string): string {
		this.getData(data);

		return this.getOutputData(version || 'v2');
	}

	private getData(data: SmartTagConvertedGarageModel): void {

		const title = data.title || data.subCategory || '';
		const isGarageBeenConverted = data.isGarageBeenConverted || null;
		const description = data.description?.trim() || '';
		if (title !== '') {
			this.title = `<span title="${title}">Type: ${title}</span>`;
		}
		if (isGarageBeenConverted !== null) {
			this.addText(`<span title="Has the garage been converted to living space?"> <i class=" ${isGarageBeenConverted ? 'fa fa-check-square' : 'fa-square far'}"></i> Has the garage been converted to living space?</span>`);
		}
		if (description !== '') {
			this.addText(`<span title="${description}">Description: ${description}</span>`);
		}
	}

}
